import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Dropdown,
  Form,
  Image,
  Row,
  Spinner,
} from "react-bootstrap";
import BreadcrumbSection from "../../../components/BreadcrumbSection";
import FilterComponent from "../../../components/FilterComponent";
import { Icon } from "@iconify/react";
import AllCategoriesComponent from "../../../components/AllCategoriesComponent";
import { useParams, useNavigate } from "react-router-dom";
import { getCategoryBySlug } from "api/CategoryService";
import { Sentry } from "react-activity";
import IMAGES from "constants/images";
import Loader from "components/Loader";
const SortDropdown = ({ sortOptions, setSortOptions }) => {
  const [enabled, setEnabled] = useState({
    ratings: false,
    pricing: false,
    reviews: false,
  });

  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    // Reset all enabled states first
    const resetEnabled = {
      ratings: false,
      pricing: false,
      reviews: false,
    };
    // Only set the clicked checkbox
    setEnabled({ ...resetEnabled, [id]: checked });

    // Reset all sort options if unchecking
    if (!checked) {
      setSortOptions({
        ratings: "",
        pricing: "",
        reviews: "",
      });
    }
  };

  const handleRadioChange = (category, value) => {
    // Reset all sort options first
    const resetOptions = {
      ratings: "",
      pricing: "",
      reviews: "",
    };
    // Only set the selected sort option
    setSortOptions({
      ...resetOptions,
      [category]: value,
    });
  };

  return (
    <Dropdown className="sortDropdown" align="end">
      <Dropdown.Toggle
        variant="light"
        className="d-flex align-items-center rounded-pill px-3"
      >
        <Icon icon="solar:sort-linear" fontSize={19} className="me-2" />
        <span className="iconFull">Sort By</span>
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ minWidth: "250px" }}>
        <Form>
          {["ratings", "pricing", "reviews"].map((type) => (
            <div key={type}>
              <Form.Check
                type="checkbox"
                id={type}
                checked={enabled[type]}
                onChange={handleCheckboxChange}
                label={
                  <strong>
                    {type.charAt(0).toUpperCase() + type.slice(1)}
                  </strong>
                }
                className="mb-3"
              />
              {enabled[type] && (
                <div>
                  {["high-to-low", "low-to-high"].map((order) => (
                    <div
                      key={order}
                      onClick={() => handleRadioChange(type, order)}
                      className="d-flex justify-content-between align-items-center px-2 py-2 sortOptionRow"
                      style={{ cursor: "pointer", borderRadius: "4px" }}
                    >
                      <span>
                        {order === "high-to-low"
                          ? "High to Low"
                          : "Low to High"}
                      </span>
                      <Form.Check
                        type="radio"
                        name={type}
                        checked={sortOptions[type] === order}
                        onChange={() => handleRadioChange(type, order)}
                        style={{ pointerEvents: "none" }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </Form>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const ProjectManagementAllSoftware = () => {
  const [filters, setFilters] = useState({
    segment: "",
    categories: [],
    industries: [],
    minPrice: "",
    maxPrice: "",
  });

  const [sortOptions, setSortOptions] = useState({
    ratings: "",
    pricing: "",
    reviews: "",
  });

  const [priceLimits, setPriceLimitsFromParent] = useState([10, 250]);
  const [catData, setCatData] = useState(null);
  // const [loadingCategory, setLoadingCategory] = useState(true);
  const { category, slug } = useParams();
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const res = await getCategoryBySlug(category, slug);
        if (res.success && res.body) {
          setCatData(res.body);
        } else {
          navigate("/not-found");
        }
      } catch (err) {
        console.error("Failed to fetch category:", err);
        navigate("/not-found");
      } finally {
        setPageLoading(false);
        // setLoadingCategory(false);
      }
    };

    if (category && slug) fetchCategory();
  }, [category, slug]);

  const handleApplyFilters = (appliedFilters) => {
    setFilters(appliedFilters);
  };

  const handleClearFilters = () => {
    setFilters({
      segment: "",
      categories: [],
      industries: [],
      minPrice: "",
      maxPrice: "",
    });
  };

  const isFilterApplied =
    filters.segment ||
    filters.categories.length > 0 ||
    filters.industries.length > 0;

  if (pageLoading) {
    return (
      <div className="loaderdiv">
        {/* <Sentry color="#e91515" size={40} speed={1} animating={true} /> */}
        <Loader />
      </div>
    );
  }

  if (!catData) {
    return (
      <Container className="py-5 text-center">
        <Col xs={12}>
          <div className="text-center py-5">
            <Image
              src={IMAGES.emptyState}
              alt=""
              height="200px"
              width="200px"
              className="mb-4"
              // className="imgUser"
            />
            <p>Category not found</p>
          </div>
        </Col>
      </Container>
    );
  }

  const catTitle = catData?.title;
  const breadcrumbTitle = [
    {
      link: `/${category}`,
      title: category.charAt(0).toUpperCase() + category.slice(1),
    },
    { title: catTitle },
  ];

  return (
    <>
      <BreadcrumbSection
        breadcrumbs={
          // Object.values(filters || {}).some((val) => val && val.length > 0)
          //   ? [{ link: `/${category}`, title: "All Products" }]
          //   :
             breadcrumbTitle
        }
      />
      <section className="software_section py-4 ">
        <Container>
          <Row className="mb-0">
            <Col lg={12}>
              <div className="software_header software_headerFlex ">
                <h2 className="textCenter">
                  {`${totalCount || 0} Listings${
                    !isFilterApplied ? ` in ${catTitle}` : ""
                  } Available`}
                </h2>
                {/* {totalCount > 0 && ( */}
                <div className="soft_dropdown">
                  <SortDropdown
                    sortOptions={sortOptions}
                    setSortOptions={setSortOptions}
                  />
                  <FilterComponent
                    onApplyFilters={handleApplyFilters}
                    onClearFilters={handleClearFilters}
                    setPriceLimitsFromParent={setPriceLimitsFromParent}
                  />
                </div>
                {/* )} */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <AllCategoriesComponent
        catData={catData}
        setTotalCount={setTotalCount}
        appliedFilters={filters}
        sortOptions={sortOptions}
      />
    </>
  );
};

export default ProjectManagementAllSoftware;
